import { useNavigate } from '@tanstack/react-router';
import { motion } from 'motion/react';
import { useEffect, useState } from 'react';
import { useTheme } from '@/hooks/useTheme';
import { useAuth } from '@/contexts/AuthContext';
import { NotificationBell } from './NotificationBell/NotificationBell';
import styles from './Header.module.scss';
import SunIcon from '@/assets/common/sun.svg?react';
import MoonIcon from '@/assets/common/moon.svg?react';

export function Header() {
  const { theme, toggleTheme } = useTheme();
  const { user, signOut, loading } = useAuth();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Check initial scroll position

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header className={`${styles.header} ${isScrolled ? styles['header--scrolled'] : ''}`}>
        <div className={styles.header__container}>
          <div className={styles.header__right}>
            {user && <NotificationBell />}

            <motion.button
              onClick={toggleTheme}
              className={styles.header__themeToggle}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
            >
              <span className={styles.header__themeToggleIcon}>
                {theme === 'light' ? <MoonIcon /> : <SunIcon />}
              </span>
            </motion.button>

            {!loading && user ? (
              <motion.button
                onClick={async () => {
                  await signOut();
                  navigate({ to: '/login' });
                }}
                className={styles.header__authButton}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Log Out
              </motion.button>
            ) : !loading && (
              <motion.button
                onClick={() => navigate({ to: '/login' })}
                className={styles.header__authButton}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Log In
              </motion.button>
            )}
          </div>
        </div>
      </header>
    </>
  );
}
